import camelcaseKeys from "camelcase-keys";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { API_HOST } from "../../config";
import { UserListContainer } from "../../containers/UserListContainer";
import { colors } from "../../design";
import history from "../../history";
import { IUser } from "../../interfaces";
import axios from "../../modules/axiosInstance";
import Icon from "../atoms/Icon";
import Input from "../atoms/Input";
import LoadingIcon from "../atoms/LoadingIcon";
import Form from "../molecules/Form";

interface IProps {
  location: {
    pathname: string;
  };
}

interface IState {
  user: IUser | null;
  displayName: string;
}

interface ITextInputEvent extends React.FormEvent<HTMLInputElement> {
  target: HTMLInputElement;
}

const UserEdit: React.FC<IProps> = ({ location }) => {
  const [user, setUser] = useState<IUser | null>(null);
  const [displayName, setDisplayName] = useState<string>("");
  const fetchUsers = UserListContainer.useContainer().fetchUsers;

  useEffect(() => {
    const userId = location.pathname.split("/")[2];
    const url = `${API_HOST}/api/users/${userId}`;
    axios
      .get(url)
      .then(results => {
        const data: any = camelcaseKeys(results.data);
        setUser(data);
        setDisplayName(data.displayName);
      })
      .catch(e => {
        console.error(e);
      });
  }, []);

  const handleChangeDisplayName = (e: ITextInputEvent) => {
    setDisplayName(e.target.value);
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!user || displayName === "") {
      return;
    }
    const url = `${API_HOST}/api/users/${user.id}`;
    const params = new URLSearchParams();
    params.append("display_name", displayName);
    axios
      .put(url, params)
      .then(response => {
        fetchUsers();
        alert("名前が変更されました。");
        history.push("/");
      })
      .catch(error => {
        console.error(error);
      });
  };

  const clearDisplayName = () => {
    setDisplayName("");
  };

  return (
    <OutWrapper className="user-edit">
      <BackLink className="user-edit__back-link">
        <Link to="/">
          <Icon className="far fa-chevron-left" />
          戻る
        </Link>
      </BackLink>
      {user ? (
        <Form onSubmit={handleSubmit}>
          <FormContent className="form-content">
            <TextInput
              type="text"
              value={displayName}
              onChange={handleChangeDisplayName}
              placeholder={user.originalName}
            />
            {displayName !== "" && (
              <ClearButton
                className="fas fa-times-circle"
                onClick={clearDisplayName}
              />
            )}
          </FormContent>
          <Submit type="submit" value="保存" />
        </Form>
      ) : (
        <LoadingIcon />
      )}
    </OutWrapper>
  );
};

const OutWrapper = styled.div`
  padding: 32px 16px;
`;
const FormContent = styled.div`
  position: relative;

  i.clear-button {
    color: $light-gray;
    opacity: 0.8;
    cursor: pointer;
    position: absolute;
    right: 10px;
    top: 14px;
  }
`;
const BackLink = styled.div`
  margin-bottom: 16px;

  a {
    font-size: 0.8rem;
    color: $light-gray;

    i {
      margin-right: 6px;
    }
  }
`;

const ClearButton = styled(Icon)`
  color: ${colors.lightGray};
  opacity: 0.8;
  cursor: pointer;
  position: absolute;
  right: 10px;
  top: 14px;
`;

const TextInput = styled(Input)`
  border: 1px solid #ddd;
  width: 100%;
  padding: 12px;
  font-size: 0.9rem;
  outline: none;
  margin-bottom: 12px;
`;

const Submit = styled(Input)`
  background-color: ${colors.lineGreen};
  width: 100%;
  border: none;
  box-shadow: 0 0 2px #ddd;
  color: #fff;
  padding: 12px;
  font-size: 0.9rem;
  outline: none;
  text-align: center;
  &:hover {
    cursor: pointer;
  }
`;

export default UserEdit;
